import { useTranslation } from "react-i18next";
function AadhaarTermsAndConditions() {
  const { t } = useTranslation("common");

  return (
    <>
      <p className="text-align-justify">{t("termsAndCondition.aadhaarTACText1")}</p>
      <p className="text-align-justify">{t("termsAndCondition.aadhaarTACText2")}</p>
    </>
  );
}

export default AadhaarTermsAndConditions;
